module.exports = __webpack_public_path__ + "img/RE.55df0a2e.svg";